export default __webpack_public_path__ + "static/media/gmail-clone.5082da3e.png";